export default __webpack_public_path__ + "c734222d46728ba94b8e7593fb5e996558312f60a681feb4920065026b437e06.svg";